import type { ErrorInfo } from "../type";

export interface PresentResponse {
  success: boolean;
  joinInfo?: string;
  error?: ErrorInfo;
}

export interface JoinResponse {
  success: boolean;
  error?: ErrorInfo;
}

export enum PPTLiveEnvironment {
  dev = "dev",
  production = "production",
}

export class PPTLiveEnvironmentConstants {
  public static Dev: string = "test.present.officeapps.live-int.com";
  public static Prod: string = "present.officeapps.live.com";
}
